import React from "react"
import styles from "./visualiser-image-area.module.css"
import { useVisualiserImageAreaViewModel } from "./VisualiserImageArea.vm"

type VisualiserImageAreaProps = {
  file?: File | null
  backgroundColor?: string
  size?: {
    width: string
    height: string
  }
  position?: {
    top?: string
    bottom?: string
    left?: string
    right?: string
  }
  borderRadius?: string
  style?: React.CSSProperties
  className?: string
  alt?: string
  scale?: number
  x?: number
  y?: number
  onUpdate?: (updates: { scale?: number; x?: number; y?: number }) => void
}

export const VisualiserImageArea = ({
  file = null,
  backgroundColor = "var(--color-neutral)",
  size,
  position,
  borderRadius = "12px",
  style,
  className,
  alt = "Uploaded image",
  scale = 1,
  x = 0,
  y = 0,
  onUpdate,
}: VisualiserImageAreaProps) => {
  const vm = useVisualiserImageAreaViewModel({
    file,
    backgroundColor,
    size,
    position,
    borderRadius,
    style,
    className,
    alt,
    scale,
    x,
    y,
    onUpdate,
    rootClassNameBase: styles["visualiser-image-area"],
  })

  return (
    <div
      ref={vm.containerRef}
      {...vm.spreadHandlers}
      onMouseDown={vm.onMouseDown}
      onMouseUp={vm.onMouseUp}
      onMouseLeave={vm.onMouseLeave}
      className={vm.rootClassName}
      style={vm.containerStyle}
    >
      {vm.hasImage ? (
        <img
          className={styles["visualiser-image-area__image"]}
          src={vm.src}
          alt={vm.alt}
          draggable={false}
          style={vm.imageStyle}
        />
      ) : (
        <div />
      )}
    </div>
  )
}
